import React from 'react';

export interface TextareaProps
  extends React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {
  label: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  function _Textarea({ label, className = '', onChange, ...props }, ref) {
    return (
      <label className="block">
        {label !== '' ? (
          <span className="text-gray-500 text-[14px] font-bold mb-2 ml-2">
            {label}
          </span>
        ) : null}
        <textarea
          className={`${
            label !== '' ? 'mb-4 mt-1' : ''
          } block w-full rounded-[5px] shadow-sm focus:border-dark-cyan focus:ring focus:ring-dark-blue focus:ring-opacity-20 bg-[#F2F2F2] border-[#BDBDBD] ${className}`}
          ref={ref}
          onChange={onChange}
          {...props}
        />
      </label>
    );
  }
);
